/**
 * Created by rhinov15 on 06/06/2017
 */
/**
 *
 * State to drag a component into scene,
 * has to be dropped in an entity to be applied to that one
 *
 * Handle Entity :
 * -Room
 * -Wall
 * -Joinery
 * -TechnicalElement
 *
 * @param component {Component} Component
 * @param unicity {boolean} Should component be unique in the designated entity
 * @param restreintTypeList {array} Integer array, list all entityType allowed if undefined will allow all handled entity
 * @constructor
 */

import { ActionState, ActionStateEnum, IdleDecoration } from "..";
import { EntityManager } from "../../plan/EntityManager";
import { EntityNode } from "../../plan/EntityNodes/EntityNode";
import { PlanManager } from "../../../../cocosPlan";
import { Commands, Component, Entity, Events, eventsManager, math, planManager, SceneConstants } from "@rhinov/savane-js";

declare var cc: any;
declare var $: any;


export class DragComponentState extends ActionState {

    state: number = ActionStateEnum.DragComponent;
    unicity: boolean;
    component: Component;
    entity: Entity;
    node: EntityNode | null;
    planPos: any = null;
    _entityTypeList: number[];
    entityHovered: Entity | null = null;

    ctrlPressed: boolean = false;
    wallDirect: boolean = false;

    constructor(entity: Entity, component: Component, unicity: boolean, restreintTypeList: number[]) {
        eventsManager.instance.dispatch(Events.HIDE_TULIP);
        super();
        this.unicity = unicity;
        this.component = component;

        // Save attached entity and create a temporary based on it
        this.entity = entity;
        this.entity.startTemporary();

        //Create a temp node
        this.node = this.createNode(this.entity);
        this.node!.setVisible(false);
        this.node!.setSelected(true);

       

        //TODO Maybe do some type verification
        if (restreintTypeList === undefined) {
            this._entityTypeList = [
                SceneConstants.EntityType.Wall,
                SceneConstants.EntityType.Room,
                SceneConstants.EntityType.Joinery,
                SceneConstants.EntityType.TechnicalElement,
                SceneConstants.EntityType.GeometryPrimitive
            ];
        } else {
            this._entityTypeList = restreintTypeList;
        }

    }

    getAction(): number {
        return this.state;
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if (keyCode == cc.KEY.escape) {
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.idleDecoration);
            return new IdleDecoration();
        }

        if (keyCode == cc.KEY.ctrl || keyCode == cc.KEY.w) {
            this.ctrlPressed = true;
        }

        return null;
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean) : ActionState | null {
        if (keyCode == cc.KEY.ctrl || keyCode == cc.KEY.w) {
            this.ctrlPressed = false;
        }

        return null;
    }

    mouseClickCancelled(cursorPosition: math.vec3) {
        if (this.entityHovered !== null) {
            this.unHighlightEntity(this.entityHovered);
        }

        PlanManager.getInstance().updateItemsSelected(null);
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.idleDecoration);
        return new IdleDecoration();
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (this.entityHovered !== null) {
            //Release click hover an entity apply component
            this.executeCommand();//TODO Inherit here
            this.unHighlightEntity(this.entityHovered);
        }

        if (!this.ctrlPressed) {
            this.node!.removeFromParent();
            this.removeNode(this.entity);

            return new IdleDecoration();
        }

        return (null);
    }

    moveMouseCursor(cursorPosition: math.vec3, test?: any, realPos?: math.vec3): ActionState | null {
        super.moveMouseCursor(cursorPosition, test as any, realPos);
        this.planPos = realPos;

        this.node!.setVisible(true);

        var newPosition = math.vec3.create();
        math.vec3.set(newPosition, cursorPosition[0], cursorPosition[1], this.entity.position[2]);
        this.entity.position = newPosition;

        $('#gameCanvas').focus();

        if (cursorPosition) {
            //Check containement in entity
            var hoveredDatas = planManager.getEntitiesAtPosition(cursorPosition, {
                rooms: this._entityTypeList.indexOf(SceneConstants.EntityType.Room) >= 0,
                walls: this._entityTypeList.indexOf(SceneConstants.EntityType.Wall) >= 0,
                joineries: this._entityTypeList.indexOf(SceneConstants.EntityType.Joinery) >= 0,
                technicalElements: this._entityTypeList.indexOf(SceneConstants.EntityType.TechnicalElement) >= 0,
                geometryPrimitives: this._entityTypeList.indexOf(SceneConstants.EntityType.GeometryPrimitive) >= 0,
            } as any, PlanManager.getInstance().world.currentScene!.currentFloor!);
            //Priority for setting coatings : Frist joinery, then walls, if no walls then look at rooms
            //TODO Handle only entity inside the allow array
            if (hoveredDatas.joineries !== undefined && hoveredDatas.joineries.length > 0) {
                //Cursor inside a joinery, highligth it
                if (this.entityHovered !== null && this.entityHovered.id !== hoveredDatas.joineries[0].id) {
                    //Unhighligth previous
                    this.unHighlightEntity(this.entityHovered);
                }
                if (this.entityHovered === null || this.entityHovered.id !== hoveredDatas.joineries[0].id) {
                    this.entityHovered = hoveredDatas.joineries[0];
                    this.highlightEntity(this.entityHovered);
                }
            } else if (hoveredDatas.technicalElements !== undefined && hoveredDatas.technicalElements.length > 0) {
                //Cursor inside a joinery, highligth it
                if (this.entityHovered !== null && this.entityHovered.id !== hoveredDatas.technicalElements[0].id) {
                    //Unhighligth previous
                    this.unHighlightEntity(this.entityHovered);
                }
                if (this.entityHovered === null || this.entityHovered.id !== hoveredDatas.technicalElements[0].id) {
                    this.entityHovered = hoveredDatas.technicalElements[0];
                    this.highlightEntity(this.entityHovered);
                }
            } else if (hoveredDatas.geometryPrimitives !== undefined && hoveredDatas.geometryPrimitives.length > 0) {
                //Cursor inside a joinery, highligth it
                if (this.entityHovered !== null && this.entityHovered.id !== hoveredDatas.geometryPrimitives[0].id) {
                    //Unhighligth previous
                    this.unHighlightEntity(this.entityHovered);
                }
                if (this.entityHovered === null || this.entityHovered.id !== hoveredDatas.geometryPrimitives[0].id) {
                    this.entityHovered = hoveredDatas.geometryPrimitives[0];
                    this.highlightEntity(this.entityHovered);
                }
            } else if (hoveredDatas.walls !== undefined && hoveredDatas.walls.length > 0) {
                //Cursor inside a room, set material to this room temporary (just to the node)
                //Get wall direction
                var localPos = math.vec3.create();
                var invertMatrix = math.mat4.create();
                math.mat4.invert(invertMatrix, hoveredDatas.walls[0].globalMatrix);
                math.vec3.transformMat4(localPos, realPos!, invertMatrix);
                var newWallDirect = (localPos[1] > 0);
                var oldWallDirect = this.wallDirect;
                this.wallDirect = newWallDirect;
                if (this.entityHovered !== null && this.entityHovered.id !== hoveredDatas.walls[0].id) {
                    this.unHighlightEntity(this.entityHovered);
                }
                if (this.entityHovered === null || this.entityHovered.id !== hoveredDatas.walls[0].id || newWallDirect !== oldWallDirect) {
                    this.entityHovered = hoveredDatas.walls[0];
                    this.highlightEntity(this.entityHovered);
                }
            } else if (hoveredDatas.rooms !== undefined && hoveredDatas.rooms.length > 0) {
                //Cursor inside a room, set material to this room temporary (just to the node)
                if (this.entityHovered !== null && this.entityHovered.id !== hoveredDatas.rooms[0].id) {
                    this.unHighlightEntity(this.entityHovered);
                }
                if (this.entityHovered === null || this.entityHovered.id !== hoveredDatas.rooms[0].id) {
                    this.entityHovered = hoveredDatas.rooms[0];
                    this.highlightEntity(this.entityHovered);
                }
            } else {
                //No entity hovered remove highligth from previously hovered entity
                if (this.entityHovered !== null) {
                    this.unHighlightEntity(this.entityHovered);
                    this.entityHovered = null;
                }
            }
        }

        this.node!.update(undefined);

        return null;
    }

    highlightEntity(entity: Entity) {
        //TODO Inherit and implement particular highligth method
        switch (entity.entityType) {
            case SceneConstants.EntityType.Joinery:
            case SceneConstants.EntityType.TechnicalElement:
            case SceneConstants.EntityType.GeometryPrimitive:
                var node = EntityManager.getInstance().getNode(entity);//PlanManager.getInstance().scrollWindow.grid.getChildByName('Joinery' + entity.id);
                node!.setHovered(true);
                break;
        }
    }
    unHighlightEntity(entity: Entity) {
        //TODO Inherit and implement particular unhighligth method
        switch (entity.entityType) {
            case SceneConstants.EntityType.Joinery:
            case SceneConstants.EntityType.TechnicalElement:
            case SceneConstants.EntityType.GeometryPrimitive:
                var node = EntityManager.getInstance().getNode(entity);//PlanManager.getInstance().scrollWindow.grid.getChildByName('Joinery' + entity.id);
                node!.setHovered(false);
                break;
        }
    }
    executeCommand() {
        //TODO Inherit and implement particular command
        PlanManager.getInstance().executeCommand(new Commands.AddComponentCommand(this.component, this.entityHovered!, this.unicity, true));
    }

    snapClick() {
        //TODO Maybe handle a generic back to idle state
        return null;
    }

    createNode(entity: Entity) {
        return EntityManager.getInstance().createNode(entity, true);
    }

    removeNode(entity: Entity) {
        EntityManager.getInstance().deleteNodeAndChild(entity);
    }

    dispose() {
        // Destroy temporary node
        this.node!.removeFromParent();
        this.removeNode(this.entity);
    }
}

